import { Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';
import { EmptyState } from '../components/ui/EmptyState';

/**
 * Guards an admin-only route, nested inside RequireAuth. The sidebar never
 * links here for a non-admin (see navItems.ts `adminOnly`). Unlike FishOil
 * (which signs the user out), a shared /users or /api-keys link opened by a
 * manager just explains that the page needs the Admin role — Multi-PERT
 * links get passed around between roles routinely.
 */
export function RequireAdmin({ children }: { children: JSX.Element }) {
  const isAdmin = useAuthStore((s) => s.user?.role === 'admin');

  if (!isAdmin) {
    return (
      <EmptyState
        icon={Lock}
        title="หน้านี้สำหรับ Admin เท่านั้น"
        description="บัญชีของคุณไม่มีสิทธิ์จัดการผู้ใช้หรือ API keys — ติดต่อผู้ดูแลระบบหากต้องการสิทธิ์เพิ่ม"
        action={
          <Link to="/projects" className="text-sm font-semibold text-primary hover:underline">
            กลับไปหน้าโปรเจกต์
          </Link>
        }
      />
    );
  }

  return children;
}
